module.exports = __webpack_public_path__ + "static/media/thankyou.fdc62e87.jpeg";